export default __webpack_public_path__ + "static/gearsOfWar-full-white-9a4de8a50204d48e12f077fc7f33c956.svg";